// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__q3tPv","search":"Settings_search__3zgox","filter":"Settings_filter__2LRPc"};